import axios from "axios";
import {
  SEND_OTP_FAIL,
  SEND_OTP_REQUECT,
  SEND_OTP_SUCCESS,
  CUSTOMER_LOGIN_FAIL,
  CUSTOMER_LOGIN_REQUEST,
  CUSTOMER_LOGIN_SUCCESS,
  CUSTOMER_LOGOUT,
  GET_LOGGED_IN_CUSTOMER_REQUEST,
  GET_LOGGED_IN_CUSTOMER_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_FAIL,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CREATE_CUSTOMER_USER_REQUEST,
  CREATE_CUSTOMER_USER_SUCCESS,
  CREATE_CUSTOMER_USER_FAIL,
  GET_CUSTOMER_USERS_REQUEST,
  GET_CUSTOMER_USERS_SUCCESS,
  GET_CUSTOMER_USERS_FAIL,
  GET_CUSTOMER_USER_BY_ID_REQUEST,
  GET_CUSTOMER_USER_BY_ID_SUCCESS,
  GET_CUSTOMER_USER_BY_ID_FAIL,
  UPDATE_CUSTOMER_USER_REQUEST,
  UPDATE_CUSTOMER_USER_SUCCESS,
  UPDATE_CUSTOMER_USER_FAIL,
  DELETE_CUSTOMER_USER_REQUEST,
  DELETE_CUSTOMER_USER_SUCCESS,
  DELETE_CUSTOMER_USER_FAIL,
  GET_CUSTOMER_USER_PERMISSION_REQUEST,
  GET_CUSTOMER_USER_PERMISSION_SUCCESS,
  GET_CUSTOMER_USER_PERMISSION_FAIL,
  GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST,
  GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL,
  UPDATE_CUSTOMER_PROFILE_REQUEST,
  UPDATE_CUSTOMER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_PROFILE_FAIL,
  GET_ALL_COUNTRY_REQUEST,
  GET_ALL_COUNTRY_SUCCESS,
  GET_ALL_COUNTRY_FAIL,
  CHANGE_PASSWORD_FROM_PROFILE_REQUEST,
  CHANGE_PASSWORD_FROM_PROFILE_SUCCESS,
  CHANGE_PASSWORD_FROM_PROFILE_FAIL,
  GET_MANAGE_BOOKING_DATA_REQUEST,
  GET_MANAGE_BOOKING_DATA_SUCCESS,
  GET_MANAGE_BOOKING_DATA_FAIL,
  CHECK_LOGGED_IN_USER_PCC_REQUEST,
  CHECK_LOGGED_IN_USER_PCC_SUCCESS,
  CHECK_LOGGED_IN_USER_PCC_FAIL,
  PRINT_ITINERARY_DATA_REQUEST,
  PRINT_ITINERARY_DATA_SUCCESS,
  PRINT_ITINERARY_DATA_FAIL,
  EMAIL_ITINERARY_DATA_REQUEST,
  EMAIL_ITINERARY_DATA_SUCCESS,
  EMAIL_ITINERARY_DATA_FAIL,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL,
  GET_LOGGED_IN_CUSTOMER_USER_REQUEST,
  GET_LOGGED_IN_CUSTOMER_USER_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_USER_FAIL,
  UPDATE_CUSTOMER_USER_PROFILE_REQUEST,
  UPDATE_CUSTOMER_USER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_USER_PROFILE_FAIL,
  GET_CUSTOMER_USER_LOGOS_REQUEST,
  GET_CUSTOMER_USER_LOGOS_SUCCESS,
  GET_CUSTOMER_USER_LOGOS_FAIL,
  DELETE_CUSTOMER_USER_LOGO_REQUEST,
  DELETE_CUSTOMER_USER_LOGO_SUCCESS,
  DELETE_CUSTOMER_USER_LOGO_FAIL,
  GET_TICKET_REPORT_REQUEST,
  GET_TICKET_REPORT_SUCCESS,
  GET_TICKET_REPORT_FAIL,
  GET_TP_BATCH_REPORT_REQUEST,
  GET_TP_BATCH_REPORT_SUCCESS,
  GET_TP_BATCH_REPORT_FAIL,
  GET_CURRENCY_REQUEST,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_FAIL,
  DOWNLOAD_EXCEL_REQUEST,
  DOWNLOAD_EXCEL_SUCCESS,
  DOWNLOAD_EXCEL_FAIL,
  DOWNLOAD_CSV_REQUEST,
  DOWNLOAD_CSV_SUCCESS,
  DOWNLOAD_CSV_FAIL,
  DOWNLOAD_INVOICE_REQUEST,
  DOWNLOAD_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_FAIL,
  EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST,
  EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS,
  EMAIL_MULTI_PCC_TICKET_REPORT_FAIL,
  GET_CUSTOMER_LOGINS_BY_ID_REQUEST,
  GET_CUSTOMER_LOGINS_BY_ID_SUCCESS,
  GET_CUSTOMER_LOGINS_BY_ID_FAIL,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL,
  GET_ALL_CUSTOMERS_REQUEST,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_FAIL,
  GET_CUSTOMER_USER_LOGS_REQUEST,
  GET_CUSTOMER_USER_LOGS_SUCCESS,
  GET_CUSTOMER_USER_LOGS_FAIL,
  GET_CUSTOMER_STATIC_DATA_REQUEST,
  GET_CUSTOMER_STATIC_DATA_SUCCESS,
  GET_CUSTOMER_STATIC_DATA_FAIL,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL,
  DELETE_CUSTOMER_LOGO_REQUEST,
  DELETE_CUSTOMER_LOGO_SUCCESS,
  DELETE_CUSTOMER_LOGO_FAIL,
  UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST,
  UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS,
  UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL,
} from "../../Constants/Constants";
import { LOCAL_URL } from "../../Constants/global";

export const login = (login_data) => async (dispatch) => {
  try {
    dispatch({
      type: CUSTOMER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/cust/login`,
      login_data,
      config
    );

    dispatch({
      type: CUSTOMER_LOGIN_SUCCESS,
      payload: data,
    });

    const expirationTime = new Date(new Date().getTime() + 12 * 60 * 60000); // 30 minutes expiration time

    localStorage.removeItem("customer_id");
    localStorage.removeItem("customer_email");
    localStorage.removeItem("customer_login_id");
    localStorage.removeItem("customer_user_id");
    localStorage.removeItem("customer_user_username");

    localStorage.setItem("userInfo", JSON.stringify(data["access_token"]));
    if (data["userType"] == "customer") {
      localStorage.setItem("customer_id", JSON.stringify(data["customer_id"]));
      localStorage.setItem("customer_email", login_data["username"]);
      localStorage.setItem(
        "customer_login_id",
        JSON.stringify(data["customer_login_id"])
      );
    }
    if (data["userType"] == "customer_user") {
      localStorage.setItem(
        "customer_user_id",
        JSON.stringify(data["customer_user_id"])
      );
      localStorage.setItem("customer_user_username", login_data["username"]);
    }
    localStorage.setItem("tokenExpiration", expirationTime);

    window.location.reload();
  } catch (error) {
    dispatch({
      type: CUSTOMER_LOGIN_FAIL,
      payload: error.response.data,
    });
  }
};

export const logout = () => async (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("customer_email");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("customer_id");
  localStorage.removeItem("customer_login_id");
  localStorage.removeItem("customer_user_id");
  localStorage.removeItem("customer_user_username");
  sessionStorage.removeItem("pnr");
  sessionStorage.removeItem("pcc");

  dispatch({
    type: CUSTOMER_LOGOUT,
  });
  window.location.reload();
};

export const sendOTP = (requestData) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_OTP_REQUECT,
    });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/cust/send_otp_mail`,
      requestData,
      config
    );

    if (requestData["userType"] == "customer") {
      if (data["customer_id"] !== undefined && data["customer_id"] !== "") {
        localStorage.setItem(
          "customer_id",
          JSON.stringify(data["customer_id"])
        );
      }
    }

    if (requestData["userType"] == "customer_user") {
      if (
        data["customer_user_id"] !== undefined &&
        data["customer_user_id"] !== ""
      ) {
        localStorage.setItem(
          "customer_user_id",
          JSON.stringify(data["customer_user_id"])
        );
      }
    }

    dispatch({
      type: SEND_OTP_SUCCESS,
      payload: data.message,
    });
    return data;
  } catch (error) {
    dispatch({
      type: SEND_OTP_FAIL,
      payload: error.response.data,
    });
  }
};

export const getLoggedInCustomer = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_LOGGED_IN_CUSTOMER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_by_id/${id}`,
      config
    );

    dispatch({ type: GET_LOGGED_IN_CUSTOMER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_LOGGED_IN_CUSTOMER_FAIL,
      payload: error.response.data,
    });
  }
};

export const changePassword =
  (user_id, change_password_data) => async (dispatch) => {
    try {
      dispatch({
        type: CHANGE_PASSWORD_REQUEST,
      });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/change_password/${user_id}`,
        change_password_data,
        config
      );

      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CHANGE_PASSWORD_FAIL,
        payload: error.response.data,
      });
    }
  };

// Create new customer user
export const createCustomerUser = (user_data) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_CUSTOMER_USER_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/cust/add_customer_user`,
      user_data,
      config
    );

    dispatch({
      type: CREATE_CUSTOMER_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_CUSTOMER_USER_FAIL,
      payload: error.response.data,
    });
  }
};

// Get all the customer users
export const getCustomerUsers =
  (cust_login_id, searchValue) => async (dispatch) => {
    try {
      dispatch({ type: GET_CUSTOMER_USERS_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/cust/get_customer_users/${cust_login_id}${
          searchValue ? `/${searchValue}` : ""
        }`,
        config
      );

      dispatch({ type: GET_CUSTOMER_USERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_USERS_FAIL,
        payload: error.response.data,
      });
    }
  };

// Get customer user by id
export const getCustomerUserById = (cust_user_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_USER_BY_ID_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_user_by_id/${cust_user_id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_USER_BY_ID_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_USER_BY_ID_FAIL,
      payload: error.response.data,
    });
  }
};

// Update customer user
export const updateCustomerUser =
  (cust_user_id, user_data) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_USER_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/update_customer_user/${cust_user_id}`,
        user_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_USER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_USER_FAIL,
        payload: error.response.data,
      });
    }
  };

// Delete Customer User
export const deleteCustomerUser = (cust_user_id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_CUSTOMER_USER_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.delete(
      `${LOCAL_URL}/cust/delete_customer_user/${cust_user_id}`,
      config
    );

    dispatch({
      type: DELETE_CUSTOMER_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOMER_USER_FAIL,
      payload: error.response.data,
    });
  }
};

// Get customer user permission
export const getCustomerUserPermissions =
  (cust_user_id) => async (dispatch) => {
    try {
      dispatch({ type: GET_CUSTOMER_USER_PERMISSION_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/cust/get_customer_user_permissions/${cust_user_id}`,
        config
      );

      dispatch({ type: GET_CUSTOMER_USER_PERMISSION_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_USER_PERMISSION_FAIL,
        payload: error.response.data,
      });
    }
  };

// Get logged in customer logins
export const getLoggedInCustomerLogins =
  (cust_login_id) => async (dispatch) => {
    try {
      dispatch({ type: GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/cust/get_logged_in_customer_logins/${cust_login_id}`,
        config
      );

      dispatch({ type: GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL,
        payload: error.response.data,
      });
    }
  };

// Update Customer profile
export const updateCustomerProfile =
  (cust_login_id, customer_data) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/update_customer_profile/${cust_login_id}`,
        customer_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_FAIL,
        payload: error.response.data,
      });
    }
  };
export const updateCustomerItinerary =
  (cust_login_id, customer_data) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/updateCustomerItinerary/${cust_login_id}`,
        customer_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_FAIL,
        payload: error.response.data,
      });
    }
  };
export const updateCustomerUserItinerary =
  (cust_login_id, customer_data) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/updateCustomerUserItinerary/${cust_login_id}`,
        customer_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_PROFILE_FAIL,
        payload: error.response.data,
      });
    }
  };
// Get all counties
export const getAllCountry = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_COUNTRY_REQUEST });

    const { data } = await axios.get("https://restcountries.com/v3.1/all");
    const countryNames = data.map((country) => country.name.common);

    dispatch({ type: GET_ALL_COUNTRY_SUCCESS, payload: countryNames });
  } catch (error) {
    dispatch({ type: GET_ALL_COUNTRY_FAIL, payload: error });
  }
};

// Change Password from profile
export const changePasswordFromProfile =
  (cust_login_id, change_password_data) => async (dispatch) => {
    try {
      dispatch({
        type: CHANGE_PASSWORD_FROM_PROFILE_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/change_password_profile/${cust_login_id}`,
        change_password_data,
        config
      );

      dispatch({
        type: CHANGE_PASSWORD_FROM_PROFILE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CHANGE_PASSWORD_FROM_PROFILE_FAIL,
        payload: error.response.data,
      });
    }
  };

// Get Manage booking data
export const getManageBookingData =
  (locator, pcc, userType, user_id = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_MANAGE_BOOKING_DATA_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/itineraryInfo/?locator=${locator}&pc=1G&pcc=${pcc}&userType=${userType}&user_id=${user_id}`,
        config
      );

      dispatch({ type: GET_MANAGE_BOOKING_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_MANAGE_BOOKING_DATA_FAIL, payload: error });
    }
  };

// Check logged in user pcc
export const checkLoggedInUserPcc = (user_id, pcc) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_LOGGED_IN_USER_PCC_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/check_logged_in_user_pcc/${user_id}/${pcc}`,
      config
    );

    dispatch({ type: CHECK_LOGGED_IN_USER_PCC_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CHECK_LOGGED_IN_USER_PCC_FAIL,
      payload: error?.response?.data,
    });
  }
};

export const printItinerary =
  (itineararyData, language, userType = null, customer_user_id = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: PRINT_ITINERARY_DATA_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
        responseType: "blob",
      };
      const url =
        userType && customer_user_id
          ? `${LOCAL_URL}/print_itinerary/${language}/${userType}/${customer_user_id}`
          : `${LOCAL_URL}/print_itinerary/${language}/${userType}`;

      const { data } = await axios.post(url, itineararyData, config);

      const blob = new Blob([data], { type: "application/pdf" });

      const pdfURL = window.URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = pdfURL;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };

      dispatch({ type: PRINT_ITINERARY_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: PRINT_ITINERARY_DATA_FAIL, payload: error });
    }
  };

export const emailItinerary =
  (
    itineararyData,
    email_data,
    language,
    userType = null,
    customer_user_id = null
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: EMAIL_ITINERARY_DATA_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const requestBody = {
        itineararyData,
        email_data,
      };

      const url =
        userType && customer_user_id
          ? `${LOCAL_URL}/email_itinerary/${language}/${userType}/${customer_user_id}`
          : `${LOCAL_URL}/email_itinerary/${language}/${userType}`;

      const { data } = await axios.post(url, requestBody, config);

      dispatch({ type: EMAIL_ITINERARY_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: EMAIL_ITINERARY_DATA_FAIL,
        payload: error.response.data,
      });
    }
  };

export const checkCustomerUserUsername = (username) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/check_customer_user_username_availability/${username}`,
      config
    );

    dispatch({
      type: CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL,
      payload: error.response.data,
    });
  }
};

export const getLoggedInCustomerUser = (cust_user_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_LOGGED_IN_CUSTOMER_USER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_logged_in_customer_user/${cust_user_id}`,
      config
    );
    dispatch({ type: GET_LOGGED_IN_CUSTOMER_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_LOGGED_IN_CUSTOMER_USER_FAIL,
      payload: error.response.data,
    });
  }
};

export const updateCustomerUserProfile =
  (cust_user_id, customer_user_data) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_CUSTOMER_USER_PROFILE_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/update_customer_user_profile/${cust_user_id}`,
        customer_user_data,
        config
      );

      dispatch({ type: UPDATE_CUSTOMER_USER_PROFILE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_USER_PROFILE_FAIL,
        payload: error.response.data,
      });
    }
  };

export const getCustomerUserLogos = (cust_user_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_USER_LOGOS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_user_logo_by_cust_user_id/${cust_user_id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_USER_LOGOS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_USER_LOGOS_FAIL,
      payload: error.response.data,
    });
  }
};

export const deleteCustomerUserLogo = (logo_id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CUSTOMER_USER_LOGO_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.delete(
      `${LOCAL_URL}/cust/delete_customer_user_logo/${logo_id}`,
      config
    );

    dispatch({ type: DELETE_CUSTOMER_USER_LOGO_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOMER_USER_LOGO_FAIL,
      payload: error.response.data,
    });
  }
};

// Get Tikcet report data
export const getTicketReport =
  (customer_id, pcc, command, report_type = "g") =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_TICKET_REPORT_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/ticket_report/?customer_id=${customer_id}&pcc=${pcc}&command=${command}&report_type=${report_type}`,
        config
      );

      dispatch({ type: GET_TICKET_REPORT_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_TICKET_REPORT_FAIL, payload: error });
    }
  };

export const getTpBatchReport =
  (customer_id, pcc, report_type, from_date, to_date, batch_id = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_TP_BATCH_REPORT_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          customer_id,
          pcc,
          report_type,
          from_date,
          to_date,
          batch_id,
        },
      };

      const { data } = await axios.get(`${LOCAL_URL}/tp_batch_report/`, config);

      dispatch({ type: GET_TP_BATCH_REPORT_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_TP_BATCH_REPORT_FAIL, payload: error });
    }
  };

// Get all currencies
export const getCurrency = () => async (dispatch) => {
  try {
    dispatch({ type: GET_CURRENCY_REQUEST });

    const { data } = await axios.get(
      "https://openexchangerates.org/api/currencies.json"
    );

    dispatch({ type: GET_CURRENCY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_CURRENCY_FAIL, payload: error });
  }
};

// Download Excel file
export const downloadExcelFile =
  (file_name, response_data, reportType = "g", fileFormat) =>
  async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_EXCEL_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
        responseType: "blob",
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/download_ticket_report_excel?file_format=${fileFormat}&report_type=${reportType}`,
        response_data,
        config
      );

      const blob = new Blob([data], {
        type:
          fileFormat === "xls"
            ? "application/vnd.ms-excel"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = file_name
        ? `${file_name}_report.${fileFormat}`
        : `Report.${fileFormat}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch({ type: DOWNLOAD_EXCEL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: DOWNLOAD_EXCEL_FAIL, payload: error });
    }
  };

// Download CSV file
export const downloadCSVFile =
  (file_name, response_data, reportType = "g") =>
  async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_CSV_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
        responseType: "blob",
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/download_ticket_report_csv?report_type=${reportType}`,
        response_data,
        config
      );

      const blob = new Blob([data], {
        type: "text/csv",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      if (file_name) {
        link.download = `${file_name}_report.csv`;
      } else {
        link.download = "Report.csv";
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch({ type: DOWNLOAD_CSV_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: DOWNLOAD_CSV_FAIL, payload: error });
    }
  };

export const downloadInvoiceFileUpdated =
  (request_data, fileFormat = "pdf") =>
  async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_INVOICE_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/download_invoice_report_pdf_live_fallback`,
        request_data,
        config
      );

      const blob = new Blob([data], {
        type:
          fileFormat === "pdf"
            ? "application/pdf"
            : fileFormat === "xls"
            ? "application/vnd.ms-excel"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(blob);

      dispatch({
        type: DOWNLOAD_INVOICE_SUCCESS,
        payload: {
          fileUrl,
          blob,
          fileName:
            fileFormat === "pdf" ? "Invoice_Report.pdf" : `Invoice_Report.${fileFormat}`,
        },
      });
    } catch (error) {
      dispatch({ type: DOWNLOAD_INVOICE_FAIL, payload: error });
    }
  };

export const emailMultiPccTicketReport = (request_data) => async (dispatch) => {
  try {
    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/send_multi_pcc_ticket_report_email`,
      request_data,
      config
    );

    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_FAIL, payload: error });
    throw error;
  }
};

export const getCustomerById = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_by_id/${id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_FAIL,
      payload: error.response.data,
    });
  }
};

export const getCustomerLoginsById = (cust_login_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_LOGINS_BY_ID_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_logins_by_id/${cust_login_id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_LOGINS_BY_ID_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_LOGINS_BY_ID_FAIL,
      payload: error.response.data,
    });
  }
};

// Update customer user default logo
export const updateCustomerUserDefaultLogo =
  (cust_user_id, default_logo_data) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/update_customer_user_default_logo/${cust_user_id}`,
        default_logo_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL,
        payload: error.response.data,
      });
    }
  };

// Get child customer by parent id
export const getChildCustomerByParentId = (parent_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_child_customers/${parent_id}`,
      config
    );

    dispatch({
      type: GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL,
      payload: error.response.data,
    });
  }
};

// Get customers
export const getCustomer = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_CUSTOMERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/cust/get_all_customer/${search_value}`
      : `${LOCAL_URL}/cust/get_all_customer`;

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_CUSTOMERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CUSTOMERS_FAIL, payload: error });
  }
};

// get customer user logs
export const getCustomerUserLogs = (cust_login_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_USER_LOGS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_users_logs_by_customer/${cust_login_id}`,
      config
    );

    dispatch({
      type: GET_CUSTOMER_USER_LOGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_USER_LOGS_FAIL,
      payload: error.response.data,
    });
  }
};

export const getCustomerStaticDataByCustID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_static_data/${id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_STATIC_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_FAIL, payload: error });
  }
};

export const getCustomerLogos = (cust_login_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/cust/get_customer_logo_by_cust_login_id/${cust_login_id}`,
      config
    );

    dispatch({
      type: GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL,
      payload: error.response.data,
    });
  }
};

export const deleteCustomerLogo = (logo_id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CUSTOMER_LOGO_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.delete(
      `${LOCAL_URL}/cust/delete_customer_logo/${logo_id}`,
      config
    );

    dispatch({ type: DELETE_CUSTOMER_LOGO_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOMER_LOGO_FAIL,
      payload: error.response.data,
    });
  }
};

// Update customer  default logo
export const updateCustomerDefaultLogo =
  (cust_login_id, default_logo_data) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/update_customer_default_logo/${cust_login_id}`,
        default_logo_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL,
        payload: error.response.data,
      });
    }
  };
